import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTheconversationComponent } from './simple-icons-theconversation.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTheconversationComponent ],
    exports:      [ SimpleIconsTheconversationComponent ],
    bootstrap:    []
})
export class SimpleIconsTheconversationModule {}
